import { Container } from '@/atoms';
import { CardBanner, Grid } from '@/molecules';
import { ProductBlock } from '@/organisms';
import { CardProductWordpress } from '@/templates';

import { cardBannerTransformer } from '@/lib/graphql/transformers';
import { removeBaseURL, toArray } from '@/lib/utils';

const ProductosFlexibleCategory = ({ bloque, id, className }: any) => {
  const products =
    bloque.productos
      ?.reduce((acc: any, curr: any) => {
        const arrayOfProducts = curr?.products?.edges.map(
          (item: any) => item.node,
        ) ?? [curr];

        return [...acc, ...arrayOfProducts];
      }, [])
      .filter(Boolean) || [];

  toArray(bloque.bannersList)
    .filter(Boolean)
    .forEach((banner: any) =>
      products.splice(banner.position, 0, banner.banner),
    );

  return (
    <Container
      id={id}
      wrapper
      as="section"
      {...(bloque.backgroundColorString
        ? {
            style: { backgroundColor: bloque.backgroundColorString },
            padding: 'px-4 py-8 md:py-16',
          }
        : {})}
      {...(className && { className })}
    >
      <ProductBlock
        {...(bloque.titulo ? { title: bloque.titulo } : {})}
        {...(bloque.link.link
          ? {
              link: {
                href: removeBaseURL(bloque.link.link.url) || '/',
                label: bloque.link.label,
                size: bloque.link.size,
                style: bloque.link.style,
              },
            }
          : {})}
        {...(bloque.description ? { description: bloque.description } : {})}
        productos={products}
        headingType={bloque.headingType}
      >
        <Grid>
          {products.map((item: any, index: number) =>
            'cpt_banner' in item ? (
              <Grid.Item
                key={item.id}
                colSpanXXS={item?.cpt_banner?.double ? 2 : 1}
              >
                <CardBanner {...cardBannerTransformer(item.cpt_banner)} />
              </Grid.Item>
            ) : (
              <Grid.Item key={item.databaseId}>
                <CardProductWordpress
                  product={item}
                  itemListName="Category Page"
                  itemIndex={index + 1}
                  numColumns={6}
                />
              </Grid.Item>
            ),
          )}
        </Grid>
      </ProductBlock>
    </Container>
  );
};

export default ProductosFlexibleCategory;

ProductosFlexibleCategory.displayName = 'ProductosFlexibleCategory';
